import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import Sidebar from "../components/dashboard/Sidebar";
import ContentArea from "../components/templates/ContentArea";
import { loadVideoTemplates } from "../thunks/dashboardThunks";
import UserProfileModal from "./Profile";
import {
  closeProfileModal,
  selectIsProfileModalOpen,
} from "../store/common/profileModalSlice";
import { getFromLocal } from "../utils/localStorage";
import ContentAreaVideo from "../components/dashboard/ContentAreaVideo";

const VideoPage = () => {
  const dispatch = useDispatch();
  const isProfileModalOpen = useSelector(selectIsProfileModalOpen);
  const id = getFromLocal("userId");

  const {
    templates: featuredTemplates,
    userTemplates,
    videoTemplate,
  } = useSelector((state) => state.templates);

  const handleCloseModal = () => {
    dispatch(closeProfileModal());
  };

  // useEffect(() => {
  //   dispatch(loadVideoTemplates());
  // }, [dispatch]);

  return (
    <div className="flex">
      <Sidebar />
      <ContentAreaVideo />
      {isProfileModalOpen && <UserProfileModal onClose={handleCloseModal} />}
    </div>
  );
};

export default VideoPage;
